import {BaseControl} from './base-control';

import {
    PhoneAutocompleteCountryInterface,
    PhoneAutocompleteValueInterface
} from '../../widgets';

import {PhoneAutocompleteControlInterface} from '../../interfaces';

export class PhoneAutocompleteControl extends BaseControl<PhoneAutocompleteValueInterface> {
    public countries: PhoneAutocompleteCountryInterface[];

    constructor(data: PhoneAutocompleteControlInterface) {
        super(data);

        this.countries = data.countries;
    }
}
